import { CategoryBadge } from './CategoryBadge';
import { getTheme, useLabel } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductKindBadge({
  kind,
  productType
}) {
  const title = useLabel(kind);
  return /*#__PURE__*/_jsx(CategoryBadge, {
    theme: getTheme(productType),
    children: title
  });
}